import miniaCrows from "../assets/images/Miniatures/minia-crows.png";
import miniaToThePeak from "../assets/images/Miniatures/minia-ttp.png";
import miniaEbw from "../assets/images/Miniatures/minia-ebw.png";

const grosProjetsData = [
    { slug: "crows-eulogy", image: miniaCrows, texte: "Crow's Eulogy", sousTexte: "Projet Synthèse - NAD" },
    { slug: "to-the-peak", image: miniaToThePeak, texte: "To the Peak", sousTexte: "7DaysFPS Jam" },
    { slug: "every-breaking-wave", image: miniaEbw, texte: "Every Breaking Wave", sousTexte: "Wonderjam #5"}
];

export default grosProjetsData;
